/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-empty-function */
/* eslint-disable no-shadow */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import * as THREE from 'three';
import * as marietta from '../..';
import { Rectangle } from '../../core';

interface svgData {
  svg: SVGElement;
  floor: number;
}

interface imageData {
  image: string;
  floor: number;
}

const imageWidth: number = 1000;
const imageHeight: number = 1000;

export default class SvgManager {
  /**
   * コンストラクタ
   */
  constructor() {
  }

  public async printSvg() {
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
    marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
    marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
    const nowScrollPosition = {
      left: $('#webcad2dViewInner').scrollLeft(),
      top: $('#webcad2dViewInner').scrollTop(),
    };
    // 画像を作る前に、スケールを調整する
    const prevScale: number = marietta.webcad.WebCADGlobal.scaleSize;
    marietta.webcad.WebCADGlobal.scrollerManager.setScale(1);
    // 余分なものを削除する
    if (document.getElementById('dragImage')) {
      document.getElementById('dragImage').remove();
    }
    const scaleArray: number[] = [];
    for (let i: number = 1; i <= 3; i += 1) {
      const target = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      const boundInfo = target.spt.getBoundingClientRect();
      let boundInfoWidth: number;
      let boundInfoHeight: number;
      if (boundInfo && boundInfo.width > 0) {
        boundInfoWidth = boundInfo.width;
        boundInfoHeight = boundInfo.height;
        let scale: number = Math.min(imageWidth / boundInfoWidth, imageHeight / boundInfoHeight);
        // スケールが不正な場合は、1にする※何も描かれていない場合に発生
        if (Number.isNaN(scale)) scale = 1;
        scaleArray.push(scale);
      }
    }
    let minScale: number = 1;
    if (scaleArray.length > 0) {
      minScale = Math.min(...scaleArray);
    }
    const svgArray: svgData[] = [];
    for (let i: number = 1; i <= 3; i += 1) {
      const tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement) {
        (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).show();
      }
      const moveDistance = marietta.webcad.WebCADGlobal.scrollerManager.moveTopLeftAndFit(i);
      const boundBox = tarLayer.getSVGMinMaxPointVisible();
      // const tarShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i, true);
      // const shitaeBoundBox = tarShitaeLayer.getSVGMinMaxPointVisible();
      // const shitaeBound = tarShitaeLayer.spt.getBoundingClientRect();
      // if (!boundBox && !shitaeBoundBox) continue;
      if (!boundBox) continue;
      let minx: number;
      let miny: number;
      let maxx: number;
      let maxy: number;
      if (boundBox) {
        minx = boundBox.min.x;
        miny = boundBox.min.y;
        maxx = boundBox.max.x;
        maxy = boundBox.max.y;
      }
      // if (shitaeBoundBox) {
      //   if (!boundBox) {
      //     boundWidth = shitaeBound.width;
      //     boundHeight = shitaeBound.height;
      //   }
      //   if (!boundBox || boundBox.min == null) {
      //     minx = shitaeBoundBox.min.x;
      //     miny = shitaeBoundBox.min.y;
      //   }
      //   if (!boundBox || boundBox.max == null) {
      //     maxx = shitaeBoundBox.min.x;
      //     maxy = shitaeBoundBox.min.y;
      //   }
      //   if (shitaeBoundBox.min.x < minx) { minx = shitaeBoundBox.min.x; }
      //   if (shitaeBoundBox.min.y < miny) { miny = shitaeBoundBox.min.y; }
      //   if (shitaeBoundBox.max.x > maxx) { maxx = shitaeBoundBox.max.x; }
      //   if (shitaeBoundBox.max.y > maxy) { maxy = shitaeBoundBox.max.y; }
      //   if (shitaeBound.width < boundWidth) { boundWidth = shitaeBound.width; }
      //   if (shitaeBound.height < boundHeight) { boundHeight = shitaeBound.height; }
      // }
      // この縦横比で台紙を作る
      // 全体を入れる場合は最終縦横比にあわせて再調整
      const floorElement = document.querySelector(`#webcad2dViewInner #layerGroup #floor${i}`).cloneNode(true);
      (<HTMLElement>floorElement).style.display = 'block';
      // const floorShitaeElement = document.querySelector(`#webcad2dViewInner #layerGroup #floorShitae${i}`).cloneNode(true);
      // (<HTMLElement>floorShitaeElement).style.display = 'block';
      const planSvg: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      planSvg.style.backgroundColor = 'rgb(255, 255, 255)';
      if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
        planSvg.removeAttribute('xmlns:NS1');
      } else {
        planSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        planSvg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      }

      const pattern = $('#patternContainer defs').clone();
      planSvg.appendChild(pattern.get(0));

      // planSvg.appendChild(floorShitaeElement);
      planSvg.appendChild(floorElement);

      // 適当な拡大率にする（仕上がりサイズの２倍にする
      const fitScale: number = minScale;

      // 最初の変換サイズ
      const imageSize = new Rectangle(0, 0, (maxx - minx), (maxy - miny));
      const marginLeft = 65;
      const marginBottom = 40;
      const translateX = (imageWidth - (imageSize.width + marginLeft) * fitScale) / 2;
      const translateY = (imageHeight - (imageSize.height + marginBottom) * fitScale) / 2;
      const contentGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      contentGroup.setAttribute('transform', `translate(${translateX}, ${translateY}) scale(${fitScale})`);
      contentGroup.appendChild(floorElement);
      planSvg.appendChild(contentGroup);
      planSvg.setAttribute('viewBox', `0 0 ${imageWidth + marginLeft} ${imageWidth + marginBottom}`);
      $(planSvg).attr('width', imageWidth + marginLeft);
      $(planSvg).attr('height', imageHeight + marginBottom);
      const svgInfo: svgData = {
        floor: i,
        svg: planSvg,
      };
      svgArray.push(svgInfo);
      marietta.webcad.WebCADGlobal.layerGroup.convertAllToSpecification({ x: -moveDistance.x, y: -moveDistance.y }, i);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement && (i !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor)) {
        (tarLayer.layer_measure as marietta.webcad.layer.MeasureLayer).hide();
      }
    }
    // スケールをもとに戻す
    marietta.webcad.WebCADGlobal.scrollerManager.setScale(prevScale);
    $('#webcad2dViewInner').scrollLeft(nowScrollPosition.left).scrollTop(nowScrollPosition.top);
    return svgArray;
  }

  /**
   * Svgを画像として作成
   * @param resolve
   */
  public async createSvgImage(resolve:Function = null) {
    const imageList: imageData[] = [];
    const svgList = await this.printSvg();
    const promiseArray = [];
    for (let i: number = 0; i < svgList.length; i += 1) {
      promiseArray.push(new Promise((resolve) => {
        const svgData = new XMLSerializer().serializeToString(svgList[i].svg);
        this.getBitmap(imageWidth, imageHeight, svgData, (data, res) => {
          const planImage = data;
          const imageInfo: imageData = {
            floor: svgList[i].floor,
            image: planImage,
          };
          imageList.push(imageInfo);
          if (res) {
            res();
          }
        }, resolve);
      }));
    }
    await Promise.all(promiseArray);
    return imageList;
  }

  /**
   * svg文字列から画像を作成する
   * @param w
   * @param h
   * @param callback
   * @param xmlData
   */
  private async getBitmap(w:number = 1000, h:number = 1000, svgData, callback: Function, resolve: Function = null) {
    const inlinedSvgData = await this.inlineExternalImages(svgData);
    const img = new Image();
    img.src = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(inlinedSvgData)))}`;
    const canvas = document.createElement('canvas');
    // get canvas context for drawing on canvas
    const context = canvas.getContext('2d');
    // set canvas size
    canvas.width = w;
    canvas.height = h;
    context.clearRect(0, 0, w, h);
    img.onload = function () {
      const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
      const x = (canvas.width / 2) - (img.width / 2) * scale;
      const y = (canvas.height / 2) - (img.height / 2) * scale;
      context.drawImage(img, x, y, img.width * scale, img.height * scale);
      // context.drawImage(img,0,0,img.width,img.height,0,0,w,h);
      // canvas.toBlob(function(blob) {
      //     callback(blob);
      // });
      callback(canvas.toDataURL('image/png'), resolve);
      canvas.remove();
    };
  }

  /**
   * プランのSVGデータを作成する
   */
  public async createPlanSvg(resolve: Function = null): Promise<SVGElement> {
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
    marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
    marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
    const nowScrollPosition = {
      left: $('#webcad2dViewInner').scrollLeft(),
      top: $('#webcad2dViewInner').scrollTop()
    };
    // 画像を作る前に、スケールを調整する
    const prevScale: number = marietta.webcad.WebCADGlobal.scaleSize;
    marietta.webcad.WebCADGlobal.scrollerManager.setScale(1);
    const moveDistance = marietta.webcad.WebCADGlobal.scrollerManager.moveTopLeftAndFit();
    // 余分なものを削除する
    if (document.getElementById('dragImage')) {
      document.getElementById('dragImage').remove();
    }

    const itemList = document.querySelectorAll('.monicaItemSvg');
    itemList.forEach((item) => {
      const boundInfo = item.getBoundingClientRect();
      item.setAttribute('data-boundinfo', JSON.stringify(boundInfo.toJSON()));
    });
    const boundBox = marietta.webcad.WebCADGlobal.layerGroup.getAllSVGBoundInfo();
    const minx: number = boundBox.min.x;
    const miny: number = boundBox.min.y;
    const maxx: number = boundBox.max.x;
    const maxy: number = boundBox.max.y;

    // この縦横比で台紙を作る
    // 全体を入れる場合は最終縦横比にあわせて再調整
    const allHeight: number = imageWidth;
    const allWidth: number = imageHeight;

    const layerGroup = $('#webcad2dViewInner').find('#layerGroup').clone();
    $(layerGroup).find('#grid').remove();
    $(layerGroup).find('#guide').remove();
    $(layerGroup).find('#optimization').remove();
    const planSvg: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    planSvg.style.backgroundColor = 'rgb(255, 255, 255)';
    if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
      planSvg.removeAttribute('xmlns:NS1');
    } else {
      planSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      planSvg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    }
    const pattern = $('#patternContainer defs').clone();
    planSvg.appendChild(pattern.get(0));
    planSvg.appendChild(layerGroup.get(0));

    // 出力画像に合わせて伸縮する最終伸縮に使用。全体保存は、縦横比を保つために実際のサイズではないサイズを保持する
    const myBounds = marietta.webcad.WebCADGlobal.layerGroup.getAllSVGBoundInfo();
    const size = myBounds.getSize(new THREE.Vector2());

    // 仕上がりサイズ
    const width: number = allWidth;
    const height: number = allHeight;

    // 適当な拡大率にする（仕上がりサイズの２倍にする
    let fitScale: number = Math.min(width / size.width, height / size.height);

    // スケールが不正な場合は、1にする※何も描かれていない場合に発生
    if (Number.isNaN(fitScale)) fitScale = 1;

    // 最初の変換サイズ
    const imageSize = new Rectangle(0, 0, (maxx - minx), (maxy - miny));
    const margin = 50;
    const translateX = (imageWidth - (imageSize.width + margin) * fitScale) / 2;
    const translateY = (imageHeight - (imageSize.height + margin) * fitScale) / 2;
    const contentGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    contentGroup.setAttribute('transform', `translate(${translateX}, ${translateY}) scale(${fitScale})`);
    $(contentGroup).append(layerGroup);
    planSvg.appendChild(contentGroup);
    planSvg.setAttribute('viewBox', `0 0 ${imageWidth + margin} ${imageWidth + margin}`);
    $(planSvg).attr('width', imageWidth + margin);
    $(planSvg).attr('height', imageHeight + margin);
    // スケールをもとに戻す
    marietta.webcad.WebCADGlobal.layerGroup.convertAllToSpecification({ x: -moveDistance.x, y: -moveDistance.y });
    marietta.webcad.WebCADGlobal.scrollerManager.setScale(prevScale);
    $('#webcad2dViewInner').scrollLeft(nowScrollPosition.left).scrollTop(nowScrollPosition.top);
    if (resolve) {
      resolve(planSvg);
    } else {
      return planSvg;
    }
  }

  /**
   * プラン SVG を Base64 データとして作成する
   * @param resolve
   * @return
   */
  public async createPlanSvgBase64(resolve: Function = null): Promise<string> {
    const svgData: SVGElement = await this.createPlanSvg();
    const svgBase64 = this.svgBase64(svgData);
    if (resolve) {
      resolve(svgBase64);
    } else {
      return svgBase64;
    }
  }

  /**
   * SVGをBase64データに変換する
   * @param svg
   * @returns
   */
  public svgBase64(svg: SVGElement) {
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBase64 = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgData)))}`;
    return svgBase64;
  }

  /**
   * フロア画像をzipファイルとしてエクスポート
   */
  public exportFloorImage(resolve: Function = null) {
    const zip = new JSZip();
    const zipFolder = zip.folder('image');
    let imageList: imageData[] = [];
    this.createSvgImage().then((result) => {
      imageList = result;
      for (let i: number = 0; i < imageList.length; i += 1) {
        const floorName = `${imageList[i].floor}F`;
        const filename = `${floorName}.png`;
        const base64Data = imageList[i].image.replace('data:image/png;base64,', '');
        zipFolder.file(filename, base64Data, { base64: true });
      }
      zip.generateAsync({ type: 'blob' }).then((content) => {
        // see FileSaver.js
        saveAs(content, 'floorImage.zip');
        if (resolve) {
          resolve();
        }
      });
    });
  }

  public fetchImageAsBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  /**
   *
   * @param svgData
   * @returns
   */
  public inlineExternalImages = async (svgData: string): Promise<string> => {
    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(svgData, 'image/svg+xml');
    const images = svgDocument.querySelectorAll('image');
    for (const image of images) {
      const href = image.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (href && !href.startsWith('data:')) {
        // Fetch the external image as base64
        const base64Image = await this.fetchImageAsBase64(href);
        // Replace href with the base64 image data
        image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', base64Image);
      }
    }
    // Serialize the updated SVG back to a string
    const serializer = new XMLSerializer();
    return serializer.serializeToString(svgDocument);
  };
}